import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { Befraktarstyrning, IKundDetail } from "../../../models/kundDetail";

export class KundDetailsModalBefraktarstyrningValidation {

    static init(styrningRow: Befraktarstyrning, data: IKundDetail): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text:"Handelssortiment måste anges och får endast finnas på en rad" },
                model: () => styrningRow.handelssortimentId,
                name: "handelssortimentRule",
                expression: (value) => !ObjectUtils.isNullOrUndefined(value) && !data.befraktarstyrningar.some(x => x.handelssortimentId === value),
                required: true

            }
        ]);

        return context;
    }
}
